const axios = require('axios').default;

export const geti18nLabels = (props = {token:"", env:""}) => {
    return axios.get(`${process.env.REACT_APP_API_URL}/api/i18n/labels`,
    {
        params: {
            env:props.env
        },
        headers: {
          'Authorization': `Basic ${props.token}`,
        }
    });
}

export const geti18nGoods = (props = {token:"", env:"", supplierId:0}) => {
    return axios.get(`${process.env.REACT_APP_API_URL}/api/i18n/goods`,
    {
        params: {
            env:props.env,
            supplierId:props.supplierId
        },
        headers: {
          'Authorization': `Basic ${props.token}`,
        }
    });
}

export const geti18nTranslations = (props = {token:"", env:""}) => {
    return axios.get(`${process.env.REACT_APP_API_URL}/api/i18n/translations`,
    {
        params: {
            env:props.env
        },
        headers: {
          'Authorization': `Basic ${props.token}`,
        }
    });
}

export const puti18nTranslations = (props = {token:"", env:"", payload:[]}) => {
    return axios.put(`${process.env.REACT_APP_API_URL}/api/i18n/translations`,props.payload,
    {
        params: {
            env:props.env
        },
        headers: {
          'Authorization': `Basic ${props.token}`,
        }
    });
}

export const posti18nTranslations = (props = {token:"", env:"", payload:[]}) => {
    return axios.post(`${process.env.REACT_APP_API_URL}/api/i18n/translations`,props.payload,
    {
        params: {
            env:props.env
        },
        headers: {
          'Authorization': `Basic ${props.token}`,
        }
    });
}

export const posti18nUnits = (props = {token:"", env:"", payload:[]}) => {
    return axios.post(`${process.env.REACT_APP_API_URL}/api/i18n/units`,props.payload,
    {
        params: {
            env:props.env
        },
        headers: {
          'Authorization': `Basic ${props.token}`,
        }
    });
}

export const posti18nProducts = (props = {token:"", env:"", payload:[]}) => {
    return axios.post(`${process.env.REACT_APP_API_URL}/api/i18n/products`,props.payload,
    {
        params: {
            env:props.env
        },
        headers: {
          'Authorization': `Basic ${props.token}`,
        }
    });
}

export const geti18nBusiness = (props = {token:"", env:"", businessId:0}) => {
    return axios.get(`${process.env.REACT_APP_API_URL}/api/i18n/business`,
    {
        params: {
            env:props.env,
            businessId:props.businessId
        },
        headers: {
          'Authorization': `Basic ${props.token}`,
        }
    });
}

export const posti18nBusiness = (props = {token:"", env:"", payload:[]}) => {
    return axios.post(`${process.env.REACT_APP_API_URL}/api/i18n/business`,props.payload,
    {
        params: {
            env:props.env
        },
        headers: {
          'Authorization': `Basic ${props.token}`,
        }
    });
}

export const geti18nBusinessSuppliers = (props = {token:"", env:"", businessId:0}) => {
    return axios.get(`${process.env.REACT_APP_API_URL}/api/i18n/business/suppliers`,
    {
        params: {
            env:props.env,
            businessId:props.businessId
        },
        headers: {
          'Authorization': `Basic ${props.token}`,
        }
    });
}

export const posti18nBusinessSuppliers = (props = {token:"", env:"", payload:[]}) => {
    return axios.post(`${process.env.REACT_APP_API_URL}/api/i18n/business/suppliers`,props.payload,
    {
        params: {
            env:props.env
        },
        headers: {
          'Authorization': `Basic ${props.token}`,
        }
    });
}